// app/providers.tsx
"use client";
import { Toaster } from "react-hot-toast";
import { PermissionProvider } from "@/app/context/permissionContext";
import { ProfileProvider } from "@/app/context/profileContext";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ProfileProvider>
      <PermissionProvider>
        {children}
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: "#1f2937",
              color: "#f1f5f9",
              border: "1px solid rgba(255,255,255,0.1)",
            },
            success: { iconTheme: { primary: "#10b981", secondary: "#f1f5f9" } },
            error: { iconTheme: { primary: "#ef4444", secondary: "#f1f5f9" } },
          }}
        />
      </PermissionProvider>
    </ProfileProvider>
  );
}